import * as Yup from 'yup'
import { hexOrRgbColorValidationNotRequired } from './TemplateDesignFormFormikValidationSchema'
import { urlPatternWithHttps } from './constants'
import { websiteValidationCheckMessage } from './messagesContants'
const ButtonCreationFormikValidationSchema = Yup.object().shape({
  buttonData: Yup.object().shape({
    name: Yup.string().required('Button name cannot be empty'),
    card: Yup.object().shape({
      customization: Yup.object().shape({
        font: Yup.string().required('Font cannot be empty'),
      }),
    }),
    buttonCustomization: Yup.object().shape({
      color: hexOrRgbColorValidationNotRequired,
      borderColor: hexOrRgbColorValidationNotRequired,
      backgroundColor: hexOrRgbColorValidationNotRequired,
    }),
    product: Yup.array().of(
      Yup.object().shape({
        url: Yup.string()
          .matches(urlPatternWithHttps, websiteValidationCheckMessage)
          .required('The URL field cannot be empty'),
      })
    ),
    //add validation here
  }),
})

export default ButtonCreationFormikValidationSchema
